module.exports = __webpack_public_path__ + "static/media/arrow-right.7e8415f9.svg";